export const formatNumber = (num: number, maximumFractionDigits: number = 0) => {
    return Intl.NumberFormat('no-NO', { maximumFractionDigits }).format(num);
};
